import { VehicleMapDataPoint } from "../../../api/types/VehicleMap";
import { TGoogleRoutePoint } from "./../../../api/types/Map";

function toRadians(deg: number): number {
  return deg * (Math.PI / 180);
}

function haversineDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371; // Earth's radius in km

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
}

export function calculateArrivalTime(
  lat1: number,
  lon1: number,
  marker: TGoogleRoutePoint,
  lastMarker: TGoogleRoutePoint
): number {
  const distanceKm = haversineDistance(
    lat1,
    lon1,
    marker?.tripPoint?.latitude ?? 0,
    marker?.tripPoint?.longitude ?? 0
  );
  const travelTimeHours =
    distanceKm / ((marker?.tripPoint as VehicleMapDataPoint)?.speedkph || 25);
  const travelTimeSec = travelTimeHours * 3600;

  const timestamp2Ms =
    marker.tripPoint?.recordid === lastMarker.tripPoint?.recordid
      ? (marker?.tripPoint?.timestamp ?? 0) - Math.floor(travelTimeSec)
      : (marker?.tripPoint?.timestamp ?? 0) + Math.floor(travelTimeSec);
  return timestamp2Ms; // or timestamp2Ms if you want raw value
}

export const getClosestMarker = (
  fromLatLng: { lat: number; lng: number },
  markers: TGoogleRoutePoint[]
): TGoogleRoutePoint | null => {
  let closest = null;
  let shortest = -1;

  markers?.forEach((marker) => {
    if (
      !marker?.tripPoint?.timestamp ||
      !marker?.location.latitude ||
      !marker?.location.longitude
    ) {
      return;
    }
    const dist = google.maps.geometry.spherical.computeDistanceBetween(
      fromLatLng,
      { lat: marker.location.latitude, lng: marker.location.longitude }
    );
    if (shortest === -1) {
      shortest = dist;
      closest = marker;
    }
    if (dist < shortest) {
      shortest = dist;
      closest = marker;
    }
  });

  return closest;
};
